var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-fullheight"},[_c('div',{staticClass:"hero-head"},[_c('the-header')],1),_c('div',{staticClass:"hero-body"},[_c('the-sidebar'),_c('main',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }